export default __webpack_public_path__ + "static/media/bags2.ceacb882.png";